//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// invite-button imports
import { IContainer, IProps, IState } from "./invite-button.d";
import { styles } from "./invite-button.styles";
// other internals
import ReduxState from "../../declarations/state.d";
import { snackBarOpen } from "@actions/snack-bar.actions";
import { updateSuggestedOrgInvite, updateOrgInvite } from "@mutations";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";
// material-ui
import { Mail } from "@material-ui/icons";
import { Button, Tooltip } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
export class InviteButtonComponent extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.onSuccess = this.onSuccess.bind(this);
    this.onFailure = this.onFailure.bind(this);

    this.state = {
      sending: false,
    };
  }

  private onSuccess = () => {
    this.setState({ sending: false });
    this.props.snackBarOpen("Invitation sent!");
  };

  private onFailure = () => {
    this.setState({ sending: false });
    this.props.snackBarOpen("Invitation failed to send :(");
  };

  private sendInvite = () => {
    const calendarIds: string[] = [this.props.invitee.targetCalendarId];
    const resolution = "Accepted" as ISchema.SuggestedOrgInviteResolution;
    this.setState({ sending: true });
    if (this.props.invitee.isSuggested) {
      updateSuggestedOrgInvite(
        this.props.relay.environment,
        { calendarIds, resolution, orgRelayId: this.props.org.id },
        this.onSuccess,
        this.onFailure,
      );
    } else {
      updateOrgInvite(
        this.props.relay.environment,
        { calendarIds, orgRelayId: this.props.org.id },
        this.onSuccess,
        this.onFailure,
      );
    }
    if (this.props.inviteCallback) {
      this.props.inviteCallback(this.props.invitee.targetCalendarId);
    }
  };

  public render(): JSX.Element {
    const { sending } = this.state;
    const { recentlySent } = this.props;

    if (!this.props.invitee.isUser) {
      return (
        <Tooltip
          title={
            this.props.invitee.isPending && !recentlySent ? "Remind them to join Clockwise" : ""
          }
          placement={"top-start"}
        >
          <Button
            variant="contained"
            className={this.props.classes.button}
            TouchRippleProps={{ classes: { ripple: this.props.classes.rippleRoot } }}
            disabled={sending || recentlySent}
            onClick={this.sendInvite}
          >
            <Mail htmlColor={greys.standard} style={{ height: 20, width: 20, marginRight: 5 }} />
            {this.state.sending ? (
              <span className={this.props.classes.label} style={this.props.labelStyle}>
                Sending...
              </span>
            ) : this.props.invitee.isPending ? (
              <span className={this.props.classes.label} style={this.props.labelStyle}>
                Invited!
              </span>
            ) : (
              <span className={this.props.classes.label} style={this.props.labelStyle}>
                Invite
              </span>
            )}
          </Button>
        </Tooltip>
      );
    } else if (this.props.invitee.isYou) {
      return <span className={this.props.classes.joined} style={this.props.joinedStyle}></span>;
    } else {
      return (
        <span className={this.props.classes.joined} style={this.props.joinedStyle}>
          Joined!
        </span>
      );
    }
  }
}

//////////////////
// STYLE
//////////////////
const InviteButtonStyled = withStyles(styles)(InviteButtonComponent);

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: ReduxState.Redux, _ownProps: IContainer) {
  return {}; // add redux state here, if needed
}

const reduxContainer = connect(mapStateToProps, {
  snackBarOpen,
})(InviteButtonStyled);

//////////////////
// RELAY
//////////////////
import { fragments } from "./InviteButton.gql";
export const InviteButton = createFragmentContainer(reduxContainer, fragments);
